/*-----------------------------------------------------------------
- Seo fields
-----------------------------------------------------------------*/
export default {};
